import Swiper, { Navigation } from 'swiper';

export default (element) => {
  const init = () => {
    const selector = element.querySelector('[data-slider]');
    const nextEl = element.querySelector('[data-nav-next]');
    const prevEl = element.querySelector('[data-nav-prev]');
    const iframes = element.querySelectorAll('.external-video-embed iframe');

    // handling for YouTube video iFrames on mobile
    if ('ontouchstart' in window || navigator.maxTouchPoints) {
      iframes.forEach((iframe) => {
        // allow YouTube iFrame API to control video
        const src = iframe.getAttribute('src');
        if (!src.includes('enablejsapi=1')) {
          iframe.setAttribute('src', `${src}${src.includes('?') ? '&' : '?'}enablejsapi=1`);
        }

        // add a transparent overlay to allow swiping past the iFrame
        const overlay = document.createElement('div');
        overlay.classList.add('external-video-embed-overlay');
        iframe.parentElement.appendChild(overlay);

        // add event listener to remove the overlay (allow interaction with video controls) and play the video
        overlay.addEventListener('click', (event) => {
          event.stopPropagation();
          overlay.remove();
          iframe.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
        });
      });
    }

    // eslint-disable-next-line no-unused-vars
    const slider = new Swiper(selector, {
      modules: [Navigation],
      simulateTouch: false,
      touchStartPreventDefault: false,
      grabCursor: false,
      resistance: 1,
      resistanceRatio: 0.5,
      slidesPerView: 1.35,
      spaceBetween: 12,
      slidesOffsetBefore: 15,
      slidesOffsetAfter: 15,
      breakpoints: {
        480: {
          slidesPerView: 2.29,
          slidesPerGroup: 2,
          spaceBetween: 12,
          slidesOffsetBefore: 15,
          slidesOffsetAfter: 15,
        },
        768: {
          slidesPerView: 3.4,
          slidesPerGroup: 3,
          spaceBetween: 15,
          slidesOffsetBefore: 40,
          slidesOffsetAfter: 40,
          navigation: {
            nextEl,
            prevEl,
          },
        },
        1280: {
          slidesPerView: 4.29,
          slidesPerGroup: 4,
          spaceBetween: 15,
          slidesOffsetBefore: 40,
          slidesOffsetAfter: 40,
          navigation: {
            nextEl,
            prevEl,
          },
        },
      },
    });
  };

  init();
};
